import DashboardIcon from "../assets/images/dashboard.svg";
import InwardIcon from "../assets/images/inwardIcon.svg";
import OutwardIcon from "../assets/images/outward_icon.svg";
import InventoryIcon from "../assets/images/inventory_icon.svg";
import ApprovalIcon from "../assets/images/approval_icon.svg";
import { EFF_DOMAIN, WMS_CUSTOMER_PORTAL_APPROVAL_USER_ID, WMS_CUSTOMER_PORTAL_USER_ID, WMS_DOMAIN } from "./utils/utils";

export const navigations = [
  { 
    name: 'Dashboard', 
    path: '/dashboard/default/', 
    img: DashboardIcon, 
    domains: [WMS_DOMAIN, EFF_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID] 
  },
  { 
    name: 'Inwards', 
    path: '/dashboard/inwardstable', 
    img: InwardIcon, 
    domains: [WMS_DOMAIN, EFF_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID] 
  },
  { 
    name: 'Outwards', 
    path: '/dashboard/outwardstable', 
    img: OutwardIcon, 
    domains: [WMS_DOMAIN, EFF_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID] },
  { 
    name: 'Inventories', 
    path: '/dashboard/inventories', 
    img: InventoryIcon, 
    domains: [WMS_DOMAIN, EFF_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID] 
  },
  { 
    name: 'RTO', 
    path: '/dashboard/rto', 
    img: InwardIcon, 
    domains: [WMS_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID] 
  },
  { 
    name: 'Outward Approval', 
    path: '/dashboard/outward-approval', 
    img: ApprovalIcon, 
    domains: [WMS_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_APPROVAL_USER_ID] 
  },
  { 
    name: 'Approval Report', 
    path: '/dashboard/reports', 
    img: InventoryIcon, 
    domains: [WMS_DOMAIN], 
    userTypeIds: [WMS_CUSTOMER_PORTAL_USER_ID, WMS_CUSTOMER_PORTAL_APPROVAL_USER_ID] 
  },
];
